import React from 'react';
import cx from 'classnames';

import I18n from 'app/common/i18n';

// import Card from 'react-material-card';
import {Checkbox} from 'material-ui';

// import ZeroStateCandidateSelectionIcon from 'app/assets/zero-state-candidate-selection.svg';

import Student from './Student';

export default class StudentList extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	wereAllStudentsSelected() {
		let {studentList = [], selectedStudents, isSelectedStudentsView, modifiedSelectedStudentList} = this.props;
		if (isSelectedStudentsView) {
			return studentList.length && studentList.length === modifiedSelectedStudentList.length;
		}
		return studentList.length && studentList.length === selectedStudents.length;
	}

	handleCheck() {
		let {studentList, updateSelectedStudents} = this.props;
		if(this.wereAllStudentsSelected()) {
			return updateSelectedStudents([]);
		}
		updateSelectedStudents(studentList);
	}

	renderStudents() {
		let {studentList=[], selectedStudents, isSelectedStudentsView, modifiedSelectedStudentList, fetchReport, updateSelectedStudents} = this.props;
		return (
			studentList.map((student, index) => {
				return (
					<Student
						key={index}
						index={index}
						student={student}
						selectedStudents={selectedStudents}
						isSelectedStudentsView={isSelectedStudentsView}
						modifiedSelectedStudentList={modifiedSelectedStudentList}
						fetchReport={fetchReport}
						updateSelectedStudents={updateSelectedStudents}/>
				);
			})
		);
	}

	renderZeroCandidatesPlaceHolder() {
		let {isSelectedStudentsView} = this.props;
		return (
			<div className='center'>

			</div>
		);
	}

	render() {
		let {studentList, selectedStudents, isSelectedStudentsView, searchText=''} = this.props;
		return (
			<div level={1} className='p2 ml2 mb2 flex flex-column mt3 white-background'>
        <div className='p2'>
  				<div className='display-none col-1 student_selection_checkbox'>
  					<Checkbox
  						inputStyle={{opacity: '0'}}
  						checked={this.wereAllStudentsSelected()}
  						onCheck={() => this.handleCheck()} />
  				</div>
  				<div className={'col-4 true-black bold'}>
  					{`${I18n.t('candidates.candidates')} (${studentList.length} ${I18n.t('candidates.matches')})`}
  				</div>
        </div>
        <div>
          {this.renderStudents()}
        </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/candidates/StudentList.js